import { render, staticRenderFns } from "./DataMappingEditor.vue?vue&type=template&id=13db533e&scoped=true&"
import script from "./DataMappingEditor.vue?vue&type=script&lang=js&"
export * from "./DataMappingEditor.vue?vue&type=script&lang=js&"
import style0 from "./DataMappingEditor.vue?vue&type=style&index=0&id=13db533e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db533e",
  null
  
)

export default component.exports